/* eslint no-unused-vars: "off" */
export default function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const { params, animating, snapGrid, slidesGrid, rtlTranslate, enabled } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));

  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapindex;
    snapGrid.forEach((snap, snapindex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapindex = snapindex;
      }
    });
    if (typeof prevSnapindex !== 'undefined') {
      prevSnap = snapGrid[prevSnapindex > 0 ? prevSnapindex - 1 : prevSnapindex];
    }
  }
  let previndex = 0;
  if (typeof prevSnap !== 'undefined') {
    previndex = slidesGrid.indexOf(prevSnap);
    if (previndex < 0) previndex = swiper.activeindex - 1;
    if (
      params.slidesPerView === 'auto' &&
      params.slidesPerGroup === 1 &&
      params.slidesPerGroupAuto
    ) {
      previndex = previndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      previndex = Math.max(previndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastindex =
      swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual
        ? swiper.virtual.slides.length - 1
        : swiper.slides.length - 1;
    return swiper.slideTo(lastindex, speed, runCallbacks, internal);
  }
  return swiper.slideTo(previndex, speed, runCallbacks, internal);
}
